import { useEffect } from 'react';
import { useRootNavigation } from '../../utils/appNavigationNames';

export const RedirectToAppOnLogin: React.FC = () => {
    const rootNavigation = useRootNavigation();
    useEffect(() => {
        // @ts-expect-error TS2345
        rootNavigation.navigate('app');
    }, [rootNavigation]);

    return null;
};
